import React from 'react';
import { get } from 'lodash';
import OriginCheckboxWidget from 'react-jsonschema-form/lib/components/widgets/CheckboxWidget';

export default function CheckboxWidget({ schema, ...props }) {
  const description = get(schema, 'title', get(props, 'options.description'));
  return <OriginCheckboxWidget {...props} schema={schema} label={description} />;
}
